import React from 'react';
import { getRankingDisplay, getRankingBadgeColor, formatRanking } from '../utils/teamRankings';

const TeamRankings = ({ rankings, loading = false }) => {
  if (loading) {
    return (
      <div className="bg-gray-800 rounded-lg p-6">
        <h3 className="text-xl font-semibold text-white mb-4">Team Rankings</h3>
        <div className="animate-pulse space-y-4">
          <div className="h-4 bg-gray-700 rounded w-3/4"></div>
          <div className="h-4 bg-gray-700 rounded w-1/2"></div>
          <div className="h-4 bg-gray-700 rounded w-2/3"></div>
        </div>
      </div>
    );
  }

  if (!rankings) {
    return (
      <div className="bg-gray-800 rounded-lg p-6">
        <h3 className="text-xl font-semibold text-white mb-4">Team Rankings</h3>
        <p className="text-gray-400">No rankings data available</p>
      </div>
    );
  }

  const cityRanking = formatRanking(rankings.city);
  const stateRanking = formatRanking(rankings.state);
  const nationalRanking = formatRanking(rankings.national);

  return (
    <div className="bg-gray-800 rounded-lg p-6">
      <h3 className="text-xl font-semibold text-white mb-4">Team Rankings</h3>
      
      {/* Rankings Grid */}
      <div className="space-y-4">
        {/* City Ranking */}
        <div className="bg-gray-700 rounded-lg p-4">
          <div className="flex items-center justify-between">
            <div>
              <h4 className="text-lg font-semibold text-white">City Ranking</h4>
              <p className="text-sm text-gray-300">
                {cityRanking.totalTeams > 0 
                  ? `Competing against ${cityRanking.totalTeams} teams in your city`
                  : 'No other teams in your city yet'
                }
              </p>
            </div>
            <div className="text-right">
              {cityRanking.position > 0 ? (
                <>
                  <div className={`inline-block px-3 py-1 rounded-full text-sm font-medium ${cityRanking.badgeColor}`}>
                    #{cityRanking.position}
                  </div>
                  <div className="text-xs text-gray-400 mt-1">
                    Top {cityRanking.percentile}%
                  </div>
                </>
              ) : (
                <div className="text-gray-400 text-sm">No ranking</div>
              )}
            </div>
          </div>
        </div>

        {/* State Ranking */}
        <div className="bg-gray-700 rounded-lg p-4">
          <div className="flex items-center justify-between">
            <div>
              <h4 className="text-lg font-semibold text-white">State Ranking</h4>
              <p className="text-sm text-gray-300">
                {stateRanking.totalTeams > 0 
                  ? `Competing against ${stateRanking.totalTeams} teams in your state`
                  : 'No other teams in your state yet'
                }
              </p>
            </div>
            <div className="text-right">
              {stateRanking.position > 0 ? (
                <>
                  <div className={`inline-block px-3 py-1 rounded-full text-sm font-medium ${stateRanking.badgeColor}`}>
                    #{stateRanking.position}
                  </div>
                  <div className="text-xs text-gray-400 mt-1">
                    Top {stateRanking.percentile}%
                  </div>
                </>
              ) : (
                <div className="text-gray-400 text-sm">No ranking</div>
              )}
            </div>
          </div>
        </div>

        {/* National Ranking */}
        <div className="bg-gray-700 rounded-lg p-4">
          <div className="flex items-center justify-between">
            <div>
              <h4 className="text-lg font-semibold text-white">National Ranking</h4>
              <p className="text-sm text-gray-300">
                {nationalRanking.totalTeams > 0 
                  ? `Competing against ${nationalRanking.totalTeams} teams nationwide`
                  : 'No other teams nationwide yet'
                }
              </p>
            </div>
            <div className="text-right">
              {nationalRanking.position > 0 ? (
                <>
                  <div className={`inline-block px-3 py-1 rounded-full text-sm font-medium ${nationalRanking.badgeColor}`}>
                    #{nationalRanking.position}
                  </div>
                  <div className="text-xs text-gray-400 mt-1">
                    Top {nationalRanking.percentile}%
                  </div>
                </>
              ) : (
                <div className="text-gray-400 text-sm">No ranking</div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Ranking Info */}
      <div className="mt-6 p-4 bg-gray-700 rounded-lg">
        <h4 className="text-sm font-semibold text-white mb-2">How Rankings Work</h4>
        <p className="text-xs text-gray-300">
          Rankings are calculated based on your team's average score, win percentage, and number of games played. 
          The more games you play, the more accurate your ranking becomes.
        </p>
      </div>
    </div>
  );
};

export default TeamRankings;


